import { __makeTemplateObject } from "tslib";
import React, { useRef, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import styled from "@emotion/styled";
import icon from "./Camera.png";
var MapStyle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .leaflet-bottom {\n    display: none;\n  }\n\n  .leaflet-container {\n    height: 430px !important;\n    border-radius: 24px;\n    z-index: 1;\n  }\n\n  @media (max-width: 1280px) {\n    .leaflet-container {\n      width: 48vw;\n    }\n  }\n\n  @media (max-width: 786px) {\n    .leaflet-container {\n      width: 90vw;\n      height: 250px !important;\n    }\n  }\n"], ["\n  .leaflet-bottom {\n    display: none;\n  }\n\n  .leaflet-container {\n    height: 430px !important;\n    border-radius: 24px;\n    z-index: 1;\n  }\n\n  @media (max-width: 1280px) {\n    .leaflet-container {\n      width: 48vw;\n    }\n  }\n\n  @media (max-width: 786px) {\n    .leaflet-container {\n      width: 90vw;\n      height: 250px !important;\n    }\n  }\n"])));
var Map = function (_a) {
    var filteredStations = _a.filteredStations, showData = _a.showData, filteredStationsByCity = _a.filteredStationsByCity, selectedStation = _a.selectedStation, updateCity = _a.updateCity, chosenCity = _a.chosenCity, lastChosenCity = _a.lastChosenCity, setUpdateCity = _a.setUpdateCity, toggleOpen = _a.toggleOpen, handleHoverMarker = _a.handleHoverMarker, handleDivHover = _a.handleDivHover, stationsInRadius = _a.stationsInRadius, stations = _a.stations;
    var regex = /(\d+\.\d+-\d+\.\d+)/g;
    var filteredStation = filteredStations.find(function (station) { return station; });
    var matches = (filteredStation === null || filteredStation === void 0 ? void 0 : filteredStation.radnoVrijeme) ? filteredStation.radnoVrijeme.match(regex) : null;
    var mapRef = useRef(null);
    var cameraIcon = L.icon({
        iconUrl: icon,
        iconSize: [32, 32],
        iconAnchor: [16, 16]
    });
    var locationIcon = L.icon({
        iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
        iconSize: [25, 40],
        iconAnchor: [16, 16]
    });
    useEffect(function () {
        var _a;
        if (mapRef.current) {
            var bounds = L.latLngBounds(stations.map(function (station) { return [station.lat, station.lon]; }));
            (_a = mapRef.current) === null || _a === void 0 ? void 0 : _a.fitBounds(bounds);
        }
    }, [stations]);
    useEffect(function () {
        if (filteredStation && (updateCity || chosenCity !== lastChosenCity) && mapRef.current) {
            var stationPosition = [filteredStation.lat, filteredStation.lon];
            mapRef.current.setView(stationPosition, 11).invalidateSize();
            setUpdateCity(false);
        }
    }, [filteredStation, updateCity, chosenCity, lastChosenCity]);
    useEffect(function () {
        if (selectedStation && mapRef.current) {
            var stationPosition = [selectedStation.lat, selectedStation.lon];
            mapRef.current.setView(stationPosition, 16);
        }
    }, [selectedStation]);
    var handleMarkerMouseOver = function (index) {
        handleHoverMarker(index, true);
    };
    var handleMarkerMouseOut = function (index) {
        handleHoverMarker(index, false);
    };
    var filteredStationsByShowData = filteredStations.filter(function (station) {
        return showData.includes(station.staniceAdresa ? station.staniceAdresa : (station.street || "N/A"));
    });
    var renderMarkers = function (stationsToRender, offset) {
        if (offset === void 0) { offset = 0; }
        return (stationsToRender.map(function (station, index) { return (React.createElement(Marker, { key: index + offset, position: [station.lat, station.lon], eventHandlers: {
                mouseover: function () { return handleMarkerMouseOver(index + offset); },
                mouseout: function () { return handleMarkerMouseOut(index + offset); }
            }, icon: !station.staniceNaziv ? cameraIcon : locationIcon },
            React.createElement(Popup, null,
                station.staniceNaziv,
                station.staniceNaziv && React.createElement("br", null),
                station.staniceAdresa ? station.staniceAdresa : station.street,
                React.createElement("br", null),
                station.stanicePPBroj && station.stanicePPBroj,
                " ",
                station.staniceMjesto ? station.staniceMjesto : station.city,
                station.staniceFax && React.createElement("br", null),
                station.staniceFax && station.staniceFax,
                station.staniceNaziv && React.createElement("br", null),
                station.staniceNaziv && matches && matches.length > 0 && React.createElement(React.Fragment, null,
                    "pon-petak ",
                    matches[0]),
                station.staniceNaziv && station.staniceNaziv && React.createElement("br", null),
                station.staniceNaziv && matches && matches.length > 0 && React.createElement(React.Fragment, null,
                    "subota ",
                    matches[matches.length - 1])))); }));
    };
    var allMarkers = renderMarkers(stations);
    var cityMarkers = renderMarkers(filteredStationsByCity || [], stations.length);
    var radiusMarkers = renderMarkers(stationsInRadius || [], stations.length + ((filteredStationsByCity === null || filteredStationsByCity === void 0 ? void 0 : filteredStationsByCity.length) || 0));
    return (React.createElement(MapStyle, null,
        React.createElement(MapContainer, { ref: mapRef, center: [45.815, 15.981], zoom: 10, scrollWheelZoom: false },
            React.createElement(TileLayer, { attribution: '\u00A9 <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors', url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" }),
            allMarkers,
            cityMarkers,
            radiusMarkers,
            filteredStationsByShowData.map(function (station, index) { return (React.createElement("div", { key: index, onMouseEnter: function () { return handleDivHover(index, true); }, onMouseLeave: function () { return handleDivHover(index, false); }, onClick: function () { return toggleOpen(station.staniceAdresa ? station.staniceAdresa : (station.street || "N/A")); } })); }))));
};
export default Map;
var templateObject_1;
//# sourceMappingURL=Map.js.map